<template lang="html">
  <div class="order-container">
    <p class="order-container__p">我的订单
      <!-- <span>(共</span><span class="num">{{total}}</span><span>条记录)</span> -->
    </p>
    <div class="order-tabs">
      <div :class="{'active':order_tab == 1}" @click="changeList(1)">已支付订单</div>
      <div :class="{'active':order_tab == 2}" @click="changeList(2)">未支付订单</div>
    </div>
    <div class="order-container-cnt" :style="{'min-height':height+'px'}">
      <div class="order-container__info">
        <div>
          <Button v-if="select_items.length != 0" size="small" type="primary" @click="goInv" style="margin-right: 20px"><i class="iconfont">&#xe619;</i>开通发票</Button>
          <Poptip trigger="hover" placement="bottom-start" width="350" class="pop">
            <Button size="small" type="primary"><i class="iconfont">&#xe631;</i>咨询客服</Button>
            <div slot="content">
              <img :src="$store.state.static_img_url+'pic/vip_layer/ewm.png'">
              <p>打开手机微信，扫一扫<br/>添加客服</p>
            </div>
          </Poptip>
        </div>
        <div class="right" v-if="order_tab == 1">
          <p>满<span>99</span>元可开具发票 请选择需要开具发票的已支付订单，支持多个订单合并开发票</p>
        </div>
      </div>
      <div class="order-container__table">
        <Table class="payment-table" v-if="order_tab == 1" :columns="order_columns" :data="order_list" @on-select="selectItem"></Table>
        <Table v-if="order_tab == 2" :columns="un_order_columns" :data="un_order_list"></Table>
        <div class="page clear" v-if="total > 10">
          <Page
            :total="total"
            :page-size="10"
            class="page_list"
            show-total
            show-elevator
            @on-change="changePage"
          />
        </div>
      </div>
      <Spin fix v-if="table_spin_show">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>
    <Modal
      class="message-model"
      title="提示"
      v-model="message_model"
      ok-text="知道了"
      >
      <p>{{message_text}}</p>
    </Modal>
    <FinishInfoAndPay ref="pay" :orderuid="order_uid" :buytype="buy_type" :flowprice="flowprice"></FinishInfoAndPay>
  </div>
</template>

<script>
import FinishInfoAndPay from '../../components/FinishInfoAndPay'
import { paymentList, noPayOrderList, getMeta, orderDetail,cancelOrder, reportDetail } from '../../service'
import filter from 'js/filter'
import { getAddPuv } from 'js/addPuv.js'
export default {
  mixins: [getAddPuv],
  data() {
    return {
      table_spin_show: false,
      order_tab: 1, // 1是已支付，2是未支付
      order_type_arr: [],
      order_list: [],
      height: 0,
      order_columns: [
        { type: 'selection', width: 100},
        { title: '购买服务', align: 'center', key: 'order_type', width: 200, render: (h, params) => {
          return h('div',[
            h('p',{class:{sp1: true}},params.row.goods_name),
            h('p',{class:{sp2: true}},filter.timeTrans(params.row.end_time) == '--'?(params.row.order_type == '0'?'活动期间有效':'永久有效'):'有效期至:'+filter.timeTrans(params.row.end_time))
          ])
        }},
        { title: '支付金额（元）', align: 'center', key: 'total', width: 200, render: (h, params) => {
          return h('p', {class:{sp1: true}}, '￥'+params.row.total)
        }},
        { title: '订单号', align: 'center', key: 'uid', render: (h, params) => {
          return h('p', {class:{sp1: true}}, params.row.transaction_uid)
        }},
        { title: '支付时间', align: 'center', key: 'update_time', width: 200, render: (h, params) => {
          return h('p', {class:{sp1: true}}, params.row.update_time)
        }},
        { title: '交易状态', align: 'center', key: 'status', width: 100, render: (h, params) => {
          return h('p', {class:{sp1: true}}, '已支付')
        }},
        { title: '开票状态', align: 'center', key: 'inv_status', width: 100, render: (h, params) => {
          if (params.row.invoice == '0') {
            return h('p', {class: {sp1: true, blue: true}}, '未开票')
          } else if(params.row.invoice == '1'){
            return h('p', {class: {sp4: true}}, '待审核')
          } else if(params.row.invoice == '2'){
            return h('p', {class: {sp4: true}}, '已开票')
          }
        }}
      ],
      un_order_list: [],
      un_order_columns: [
        { title: '购买服务', align: 'center', key: 'order_type', width: 300, render: (h, params) => {
          return h('p',{class:{sp1: true}},params.row.goods_name)
        }},
        { title: '支付金额（元）', align: 'center', key: 'pay_total', width: 200, render: (h, params) => {
          return h('p', {class:{sp1: true}}, '￥'+params.row.pay_total)
        }},
        { title: '订单号', align: 'center', key: 'uid', render: (h, params) => {
          return h('p', {class:{sp1: true}}, params.row.uid)
        }},
        { title: '创建时间', align: 'center', key: 'create_time', width: 200, render: (h, params) => {
          return h('p', {class:{sp1: true}}, params.row.create_time)
        }},
        { title: '交易状态', align: 'center', key: 'pay_status', width: 100, render: (h, params) => {
          return h('p', {class:{sp5: true}}, '待支付')
        }},
        { title: '操作', align: 'center', key: 'do', width: 160, render: (h, params) => {
          if (params.row.order_type == '1' || params.row.order_type == '8' || params.row.order_type == '13') {
            return h('div',[
              h('span', {class: {sp3: true}, on: {click:() => {this.goPay(params.row)}}}, '去支付'),
              h('span', {class: {sp3: true}, on: {click:() => {this.cancelOrder(params.row)}}}, '取消'),
            ])
          } else {
            return h('p', {class: {sp4: true}}, '已关闭')
          }
        }}
      ],
      page: 1, // 翻页
      total: 0, // 总数

      select_items: [], // 已选择的表格item
      message_model: false,
      message_text: '',

      buy_type: 1, // 待支付需要支付的类型
      order_uid: '', // 订单uid
      flowprice: ''
    }
  },
  components: {
    FinishInfoAndPay
  },
  methods: {
    async getPayType() { // 获取订单类型
      let res = await getMeta({
        name: ['payment_goodsname']
      }, (error) => { this.$Message.error('元数据请求错误！') })
      if(res.status == 'success') {
        this.order_type_arr = res.meta.payment_goodsname
      } else {
        this.$Message.error(res.message)
      }
    },
    async getList() { // 获取列表
      let res
      if (this.order_tab == 1) { // 已支付
        res = await paymentList({
          user_key: this.$store.state.user_key,
          page: this.page
        }, (err) => {this.$Message.error('请求错误')})
      } else { // 未支付
        res = await noPayOrderList({
          user_key: this.$store.state.user_key,
          page: this.page,
          type: ''
        }, (err) => {this.$Message.error('请求错误')})
      }
      if (res.status == 'success') {
        if(this.page == 1) {
          this.total = res.count
        }
        if (this.order_tab == 1) {
          this.order_list = res.res
        } else {
          this.un_order_list = res.res
        }
      } else {
        this.$Message.error(res.message)
      }
      this.table_spin_show = false
    },
    changeList(tab) { // 点击tab
      this.order_tab = tab
      this.table_spin_show = true
      this.select_items = []
      this.page = 1
      this.getList()
    },
    changePage(page) { // 翻页
      this.page = page
      this.getList()
    },
    selectItem(selection, row) { // 选取
      this.select_items = selection
    },
    goInv() { // 开发票
      let price = 0

      for(let i of this.select_items) {
        if (i.invoice != '0') {
          this.message_text = '亲，有订单已经开过发票了哦~'
          this.message_model = true
          return
        }
        price = price + parseFloat(i.total)
      }
      if (price < 99) {
        this.message_text = '亲，订单满99才可以开具发票哦~'
        this.message_model = true
        return
      }
      this.$store.commit('updateOrderArr', this.select_items.map((item) => item.uid))
      this.$router.push({name: 'OpenInv', query: {price: price}})
    },
    async cancelOrder(row) {
      let res = await cancelOrder({
        user_key: this.$store.state.user_key,
        uid: row.uid,
        type: row.order_type
      }, (error) => {
        this.$Message.error('订单验证请求错误！')
      })
      if (res.status == 'success') {
        this.$Message.success('取消成功！')
        let index = this.un_order_list.findIndex((a) => a.uid == row.uid)
        this.un_order_list.splice(index, 1)
      } else {
        this.$Message.error(res.message)
      }
    },
    async goPay(row) { // 去支付
      this.order_uid = row.uid
      this.buy_type = row.order_type
      this.flowprice = row.pay_total
      if (row.order_type == '1') {
        let res = await orderDetail({
          user_key: this.$store.state.user_key,
          uid: row.uid,
          type: row.order_type
        })
        let res1 = await reportDetail({
          user_key: this.$store.state.user_key,
          uid: res.res[0].report_uid,
        })
        if (res1.res[0].buy_status == '1') {
          this.message_text = '亲，此报告您已经买过了哦~'
          this.message_model = true
          return
        }
        setTimeout(() => {
          this.$refs['pay'].showInfo(3, res.res[0].title || '购买报告', this.getList)
        }, 500)
      }
      if (row.order_type == '8') {
        setTimeout(() => {
          this.$refs['pay'].showInfo(3, 'VIP会员', this.getList)
        }, 500)
      }
    }
  },
  created() {
    this.getPayType()
    this.getList()
    let url = window.location.href
    this.getAddPuv(url)
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 203
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.order-container
  width: 1200px;
  margin: 0 auto 20px;
  &__p
    padding-top: 30px;
    commonColor(#ffffff, #333333)
    font-size: 18px;
    padding-bottom: 20px;
    vertical-align: text-bottom;
    span
      color:#999999;
      font-size: 14px;
      &:nth-child(1)
        margin-left: 10px;
      &.num
        color: rgba(250, 122, 80, 1);
  .order-tabs
    display: flex;
    color: #999999;
    commonBgColor(#2A2F42, #FFFAF5)
    div
      width: 200px;
      text-align: center;
      padding: 15px 16px;
      margin-right: 16px;
      cursor: pointer;
      line-height: 1.5;
      font-size: 14px;
      position: relative;
      commonColor( #BCBDC1, #999)
      &.active
        commonBgColor(#1F2330, #ffffff);
        commonColor(#fff, #333);
        &:before
          height: 2px;
          content: '';
          width: 100%;
          background-color: rgba(250, 122, 80, 1);
          position: absolute;
          left: 0;
          top: 0;
  .order-container-cnt
    commonBgColor(#1F2330, #fff)
    position: relative;
    padding: 30px
  &__info
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    button
      background-color: rgba(250, 122, 80, 1);
      border-color: rgba(250, 122, 80, 1);
      display: inline-flex;
      align-items: center;
      >>>span
        margin-top: 2px;
        vertical-align: text-bottom;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      i
        margin-right: 8px;
    >>> .ivu-poptip-arrow
      display: none;
    >>> .ivu-poptip-inner
      commonBgColor(#1F2330, #ffffff);
      commonShadow(0px 3px 18px 0px rgba(0, 0, 0, 0.94), 0px 3px 18px 0px rgba(0, 0, 0, 0.2))
      border-radius:6px;
      .ivu-poptip-body
        padding: 0px;
        &-content
          background-image: url('~pic/kefu_hover.png');
          background-repeat: no-repeat;
          background-position: 100% -30%;
          background-size: auto;
          >div
            padding: 10px;
            display: flex;
            align-items: center;
            img
              width: 130px;
              height: 130px;
              display: block;
            p
              margin-left: 12px;
              font-size:14px;
              commonColor(#fff, #333333);
    .right
      text-align: right;
      p
        commonColor( #BCBDC1, #666)
        font-size:14px;
        vertical-align: text-bottom;
        span
          color: rgba(250, 122, 80, 1);
          font-size: 18px;
      p+p
        margin-top: 10px;
  &__table
    padding: 0;
    position: relative;
    min-height: 300px;
    >>> .ivu-table-tbody
      .ivu-table-row:nth-of-type(even)
        commonBgColor(#2A2F42, #FFFAF5)
    .payment-table
      >>>
        thead
          th:first-child
            >div
              display: none;
    >>>
      .sp1
        font-size: 14px;
        commonColor(#FFFFFF, #333333);
        &.blue
          color: rgba(250, 122, 80, 1)
      .sp2
        font-size: 12px;
        color: #999999;
        margin-top: 6px;
      .sp3
        font-size: 14px;
        commonColor(#FFFFFF, rgba(250, 122, 80, 1));
        text-decoration: underline;
        cursor: pointer;
        & + .sp3
          margin-left: 15px;
      .sp4
        font-size: 14px;
        color: #999999;
      .sp5
        font-size: 14px;
        color: #FC3B3B;
      .ivu-checkbox
        font-size: 0
        margin-right: 8px
        .ivu-checkbox-inner
          margin-top: 1px
          display: inline-block
          vertical-align: top
          background: transparent
          commonBorderColor(#7A7F94, #D5D5D5)
        &:hover
          .ivu-checkbox-inner
            commonBorderColor(rgba(250, 122, 80, 1), #23294D)
        &-focus
          box-shadow: none
        &.ivu-checkbox-checked
          .ivu-checkbox-inner
            commonBorderColor(rgba(250, 122, 80, 1), #23294D)
            commonBgColor(rgba(250, 122, 80, 1), #23294D)
      span.ivu-checkbox+*
        display: inline-block
        line-height: 18px
        font-size: 13px
        commonColor(#BCBDC1, #333333)
        vertical-align: top
        margin: 0
        &:hover
          color: rgba(250, 122, 80, 1) !important
.message-model
  >>>.ivu-modal
      button:first-child
        display: none;
      button:last-child
        background-color: rgba(250, 122, 80, 1)
        border-color: rgba(250, 122, 80, 1)
</style>
